<template>
    <img src="/static/images/logo.png">
</template>

<script>
export default {
    name: 'Logo'
};
</script>

<style scoped>
    img {
        display: flex;
    }
</style>



// WEBPACK FOOTER //
// src/components/Logo.vue